import React from 'react'
import { compose, withProps } from 'recompose'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps'

const MyMapComponent = compose(
  withProps({
    googleMapURL:
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}&v=3.exp&libraries=places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: (
      <div style={{ height: `100px`, width: `90vw`, pointerEvents: 'none' }} />
    ),
    mapElement: <div style={{ height: `100%` }} />,
    disableDefaultUI: true,
    clickableIcons: false,
    fullscreenControl: false
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={props.zoom}
    center={{ lat: props.lat, lng: props.lng }}
    clickableIcons={false}
    fullscreenControl={false}
    disableDefaultUI
    options={{
      styles: [
        {
          featureType: 'all',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.text',
          stylers: [
            {
              color: '#444444'
            }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'administrative.province',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.locality',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            },
            {
              saturation: '-100'
            },
            {
              lightness: '30'
            }
          ]
        },
        {
          featureType: 'administrative.neighborhood',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            },
            {
              gamma: '0.00'
            },
            {
              lightness: '74'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'simplified'
            },
            {
              color: '#ff0000'
            },
            {
              saturation: '-15'
            },
            {
              lightness: '40'
            },
            {
              gamma: '1.25'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ff0000'
            },
            {
              lightness: '80'
            }
          ]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#efefef'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        }
      ]
    }}
  >
    {props.isMarkerShown && (
      <Marker position={{ lat: props.lat, lng: props.lng }} />
    )}
  </GoogleMap>
))

export default MyMapComponent
